import React from "react";
import Link from "next/link";
import { useState, useEffect } from "react";
// import Image from "next/image";
import { convertToImageKit } from "../../utils/convert-to-imagekit";
import useWindowSize from "../../hooks/useWindowSize";
import LazyLoad from "react-lazyload";
import styles from "../../pages/current-affairs/blog/[slug].module.scss";

const SideBanner = ({ language }) => {
  const [sideBanner, setSideBanner] = useState(null);
  const size = useWindowSize();

  useEffect(() => {
    const getSideBanner = async () => {
      const url = `https://api.toppersnotes.com/api/ca/get/banners?type=blog&lang=${language}`;

      let data = await fetch(url);
      let parsedData = await data.json();
      setSideBanner(parsedData);
    };
    getSideBanner();
  }, []);

  const myLoader = ({ src, width }) => {
    return src + `?tr=w-${size.width}`;
  };

  return (
    <div className={styles["side-banner-component"]}>
      {sideBanner &&
        sideBanner.map((banner) => {
          return (
            <div
              className={`${styles["side-banner"]} pt-2 pl-4 flex justify-center items-center ${styles.sidebarBanner}`}
            >
              {banner && banner.position === "sidebar" ? (
                <>
                  <Link href={banner && banner.link}>
                    <a>
                      <div
                        className={`${styles["image-banner"]} h-80 w-80 bg-inherit bg-center rounded-md shadow`}
                      >
                        {/* <img
                          className="h-full w-full object-fill "
                          src={banner && banner.image}
                          alt={banner && banner.name}
                        /> */}
                        <LazyLoad once>
                          <img
                            width={800}
                            height={800}
                            src={convertToImageKit(banner.image, "app")}
                            alt={banner.name}
                          />
                          {/* <Image
                            unoptimized={true}
                            loader={myLoader}
                            width={800}
                            height={800}
                            src={convertToImageKit(banner.image, "app")}
                            alt={banner.name}
                            priority={true}
                          /> */}
                        </LazyLoad>
                      </div>
                    </a>
                  </Link>
                </>
              ) : (
                <>
                  {/* <Link href={banner && banner.link}>
                    <a>
                      <div className="image-banner h-44 w-80 bg-inherit bg-center rounded-md shadow">
                        <img
                          className="h-full w-full object-fill"
                          src={banner && banner.image}
                          alt={banner && banner.name}
                        />
                      </div>
                    </a>
                  </Link> */}
                </>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default SideBanner;
